<template>
  <portal
    v-if="competitions.length > 1"
    to="tertiary"
  >
    <ul class="list-reset flex">
      <li
        class="mr-8"
      >
        <a
          :href="route(routeName, fundingPot.id)"
          class="text-black hover:opacity-75 py-2 block"
          :class="{
            'no-underline' : selected,
            'underline' : !selected
          }"
          @click.prevent="selected = false"
        >
          All Competitions
        </a>
      </li>
      <li
        v-for="competition in competitions"
        :key="competition.uuid"
        class="mr-8"
      >
        <a
          :href="`?competition=${competition.uuid}`"
          class="text-black hover:opacity-75 py-2 block"
          :class="{
            'no-underline' : selected !== competition.uuid,
            'underline' : selected === competition.uuid
          }"
          @click.prevent="selected = competition.uuid"
        >
          {{ competition.title }}
        </a>
      </li>
    </ul>
  </portal>
</template>

<script>
export default {
  name: 'FundingProjectFilter',
  props: {
    routeName: {
      type: String,
      required: true
    },
    competitions: {
      type: Array,
      required: true
    },
    fundingPot: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: null
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler(value) {
        return this.$emit('filter:selected', value)
      }
    }
  },
  created() {
    this.selected = this.getQueryParameterByName('competition')
  }
}
</script>
